import Polyglot from 'node-polyglot'

export default new Polyglot()
